/** 라우트 메뉴 코드 — 2.0 게시판은 RP14, 1.0 TS05 는 iframe 캐치올 그대로(LOGISPRD-15070). */
export const BOARD_MENU_CODE = 'rp14'
export const BOARD_BASE_PATH = '/rp/rp14'

export const NOTICE_CATEGORY = '공지사항'
/** 1.0 화면 메타 `/api/common/gridsub` TS05 `CATEGORY` COMBO 와 같은 값·순서. */
export const BOARD_CATEGORIES = ['시스템오류', '데이터확인', NOTICE_CATEGORY, 'VOC'] as const

/** 공지 대상 — 전체공지. */
export const NOTICE_TARGET_ALL = 'ALL'
/** 공지 분류를 보여 줄 권한(BE `assertCanEditAllShipperRow` 와 같은 코드 — 최종 판정은 서버). */
export const NOTICE_AUTH_CODES = ['MASTER', 'MOMS_ENG']

/** BE 컬럼 길이·상한 (SPEC-infra-ts05-board-A.yaml api.create·comment-create). */
export const CATEGORY_MAX_LENGTH = 100
export const TITLE_MAX_LENGTH = 500
export const COMMENT_MAX_LENGTH = 5000
export const MAX_ATTACHMENTS = 20

export const BOARD_PAGE_SIZE = 20
